export default __webpack_public_path__ + "media/images/logos/ipaf-logo-630af9b2e969346d1fccd2bceaff05dc.png";